<template>
  <div class="tla-progress"
    :class="{ 'tla-progress--thin': isThin, 'tla-progress--first': isFirst, 'tla-progress--navigation': showNavigation }">
    <h4 class="tla-progress__heading">{{ progressBarLabel }} {{ progressBarPercentage }}</h4>
    <div class="tla-progress__container">
      <button v-if="showNavigation" type="button" class="tla-progress__navigation tla-progress__navigation--prev"
        @click="submitPreviousStep()" :disabled="currentStep === 1">
      </button>
      <progress class="tla-progress__bar" :class="{ 'tla-progress__flat': flatStyling }" :value="progressBarValue" max="100"></progress>
      <button v-if="showNavigation" type="button" class="tla-progress__navigation"
        :class="{ 'tla-progress__navigation--next': !hideForwardNavigation }" @click="submitNextStep()"
        :disabled="invalid">
      </button>
    </div>
  </div>
</template>

<script lang='ts'>
import {
  Validator
} from 'vee-validate';
import {
  Component,
  Prop,
  Vue,
  Inject
} from 'vue-property-decorator';
import BeforeUnloadService from '../../services/BeforeUnloadService';

@Component
export default class ProgressBarComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 0 })
  public progressBarValue!: number;

  @Prop({ default: 'Overall Progress' })
  public progressBarLabel!: string;

  @Prop({ default: false })
  public isThin!: boolean;

  @Prop({ default: false })
  public isFirst!: boolean;

  @Prop({ default: false })
  public hidePercentage!: boolean;

  @Prop({ default: false })
  public hideForwardNavigation!: boolean;

  @Prop({ default: false })
  public hideBackwardNavigation!: boolean;

  @Prop({ default: false })
  public flatStyling!: boolean;

  @Prop({ default: 1 })
  public nextStep!: number;

  @Prop({ default: 1 })
  public previousStep!: number;

  @Prop({ default: null })
  public validationScope!: string;

  public get progressBarPercentage() {
    return this.hidePercentage ? '' : `${this.progressBarValue}%`;
  }

  public get showNavigation() {
    return this.$store.getters['initialSettingsModule/allowFullNavigation'];
  }

  public get currentStep(): number {
    return this.$store.getters['enquiryModule/currentStep'];
  }

  public submitNextStep() {
    this.$store.dispatch('enquiryModule/submitNextStep', this.currentStep + this.nextStep);
  }

  public submitPreviousStep() {
    this.$store.dispatch('enquiryModule/submitNextStep', this.currentStep - this.previousStep);
  }

  public get invalid(): boolean {
    return this.$validator.errors.items.filter((x) => x.scope === this.validationScope).length > 0;
  }

  mounted() {
    BeforeUnloadService.addBeforeUnloadListener();
  }

  beforeDestroy() {
    BeforeUnloadService.removeBeforeUnloadListener();
  }
}
</script>
